// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialSeo__root--1Yhcr","justified":"SocialSeo__justified--2K79g","input":"SocialSeo__input--1QSxM"};